module.exports = {
    projectName: "Svend Walter Music/Live Entertainment",
    operatorEmail: "info@svend-walter.de",

    allBccTo: "info@svend-walter.de",

    apiBase:"https://svend-walter.com/api/",
    frontendBase:"https://svend-walter.com/",

    publicToken: "UbnbyTPTZGqtndL5udQw",
    ssrToken: "TowendQhi",

    ssrValidatePath: function (path) {
        // TODO validate if path ssr rendering is ok, -1 = NOTFOUND, 0 = NO SSR, 1 = SSR
        // pe. use context.readCollection("product", {filter: {path: path}}) ... to validate dynamic urls

        return 0
        return path.match(/^\/(home|service)\/?$/)
    },
}
